import { useRef } from "react";
import "react-html5-camera-photo/build/css/index.css";
import { FirebaseContext, initFirebase } from "src/helpers/firebase";
import { ImageCacheContext } from "src/helpers/imageCache";

import "./styles/globals.css";
import "./styles/imagePreview.css";

// Import i18n configuration
import "./config/i18n";

import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import { CookieConsent } from "./components/CookieConsent/CookieConsent";
import { AppRoutes } from "./AppRoutes";

const Application = () => {
  const cache = useRef(new Map<string, string>());
  return (
    <>
      <Toaster />
      <ImageCacheContext.Provider value={cache}>
        <FirebaseContext.Provider value={initFirebase()}>
          <BrowserRouter>
            <AppRoutes />
            <CookieConsent />
          </BrowserRouter>
        </FirebaseContext.Provider>
      </ImageCacheContext.Provider>
    </>
  );
};

export default Application;
